
/** Start Check Ultimate Hex & Xtreme Product **/
 $(document).ready(function(){
		var currentProductHandle  = $(".product_form").attr("data-product-handle");
		//var lastItem = currentProductHandle.split("-").pop();
		console.log(currentProductHandle);
		var xtremeHandle = "xtreme-3d-car-mat";
		var ultimateHandle = "hex-ultimate";
		if(currentProductHandle.indexOf(xtremeHandle) != -1){
			var lastItem = currentProductHandle.split("-").slice(-4).join("-");
		}else if(currentProductHandle.indexOf(ultimateHandle) != -1){
			var lastItem = currentProductHandle.split("-").slice(-2).join("-");
		}else{
		  var lastItem = currentProductHandle.split("-").pop();
		}
		console.log(lastItem);

       var selectProductClassic = currentProductHandle.replaceAll(lastItem, "classic" );
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductClassic + '.js', function(product) {
			//console.log(product);
           $('#classic-type').css('visibility','visible');
		  }).fail(function() {
		   $('#classic-type').hide();
		  });

     var selectProductEco = currentProductHandle.replaceAll(lastItem, "eco" );
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductEco + '.js', function(product) {
			//console.log(product);
           $('#eco-type').css('visibility','visible');
		  }).fail(function() {
		   $('#eco-type').hide();
		  });

   var selectProductHex = currentProductHandle.replaceAll(lastItem, "hex" );
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductHex + '.js', function(product) {
			//console.log(product);
           $('#hex-type').css('visibility','visible');
		  }).fail(function() {
		   $('#hex-type').hide();
		  });
  
	 
		 var selectProductUltimate = currentProductHandle.replaceAll(lastItem, "hex-ultimate" );
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductUltimate + '.js', function(product) {
			//console.log(product);
           $('#ultimatehex-type').css('visibility','visible');
		  }).fail(function() {
		   $('#ultimatehex-type').hide();
		  });
   
  });

/** End Check Ultimate Hex & Xtreme Product **/


var $product_img_cell = $(".variant_imgs_cell"), 
    $product_img_cell_array = [],
    $product_slider = $("#productImg").flickity();
	$product_slider.flickity("destroy"),
    $(function() {
        productImgArray(), imageUpdater();
    }),
    (productImgArray = () => {
        $product_img_cell.each(function() {
            var r = $(this);
            $product_img_cell_array = $product_img_cell_array.concat(r);
        });
    }),
    (getSelectedVariantValue = () => {
        var a = "";
        return (
            $(".swatch_alt_val").each(function() {
                var r = $(this);
                r.prop("checked") && ((r = r.val()), (a += r + "-"));
            }),
            (a = a.replace(/-\s*$/, ""))
        );
    }),
    (imageUpdater = (r) => {
        var t = getSelectedVariantValue(),
        a = 0;
		var radioValue = 'Automatic';
        var altArray = t.split('-');
        var newAltArr = altArray.slice(0, -1); 
        newAltArr.splice(1, 0, radioValue);
        var altStr = newAltArr.toString();
        var t = altStr.replace(/,/g, '-');
      
      var currentProductHandle  = $(".product_form").attr("data-product-handle");
    var lastItem = currentProductHandle.split("-").pop();
     
      //console.log(lastItem);
        $product_img_cell.each(function() {
                $(this).remove();
                for (var r = 0; r < $product_img_cell_array.length; r++) {
                    var a = $product_img_cell_array[r].attr("data-title");
                    (t != a && "main_image" != a && "main_image_hex" != a) || $("#productImg .flickity-slider").append($product_img_cell_array[r]);
                }
            });
          if(lastItem == 'hex'){
            $('.swatch-element-type.selected').removeClass('selected');
            (a = r ? 2 : 0);
          }else{
            (a = r ? 1 : 0);
          }
            
            $product_slider.flickity("destroy"),
            $("#productImg").flickity({
                pageDots: !0,
                initialIndex: a
            });
    }),
    (changeSwatch = (r) => {
        $(r);
        setTimeout(function() {
            imageUpdater(!0);
        }, 500);
    }),


  (changeType = (tr) => {
    $('.swatch-element-type.selected').removeClass('selected');
    $(tr).addClass('selected');
    var typeValue = $(tr).attr('data-value'); 
    $("input[value=" + typeValue + "]").attr('checked', 'checked');
    var currentProductHandle  = $(".product_form").attr("data-product-handle");
    var xtremeHandle = "xtreme-3d-car-mat";
	var ultimateHandle = "hex-ultimate";
    if(currentProductHandle.indexOf(xtremeHandle) != -1){
        var lastItem = currentProductHandle.split("-").slice(-4).join("-");
    }else if(currentProductHandle.indexOf(ultimateHandle) != -1){
		var lastItem = currentProductHandle.split("-").slice(-2).join("-");
	}else{
      var lastItem = currentProductHandle.split("-").pop();
    }
    console.log(lastItem);
    
    if(typeValue == 'Classic'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "classic");
    }
    else if(typeValue == 'Hex'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "hex" );
    }
    else if(typeValue == 'Eco'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "eco" );
    }
    else if(typeValue == 'Ultimate-Hex'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "hex-ultimate" );
    }
    

    window.location.href = "/products/"+selectProductType;
    
    //window.location.href = "/products/"+selectProductType;
    /*var fullProductUrl = "https://my.trapo.asia/products/"+selectProductType;
    $.get( fullProductUrl, function( data ) {
        console.log(data);   
      //var productHtml = data.find(".shopify-section--product-template").html();
       //console.log(productHtml); 
      $(".shopify-section--product-template").empty();
      //console.log($(data).find(".section-wrapper").html());
      $('.shopify-section--product-template').append($(data).find(".shopify-section--product-template").html());
    });
    /*jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductType + '.js', function(product) {
      console.log(product);
      var $productImages = product.media;
      console.log($productImages);
      $productImages.forEach(function(item) {
         console.log(item.src);
      });
  
    });*/
  }),

  (changeImage = (tr) => {
    $(tr).addClass('selected');
    $(tr);
        setTimeout(function() {
            imageUpdaterNew(!0);
        }, 500);
  }),
  (imageUpdaterNew = (tr) => {
        var t = getSelectedVariantValue();
    console.log(t);
        a = 0;
		var radioValue = 'Automatic';
        var altArray = t.split('-');
        var newAltArr = altArray.slice(0, -1); 
        newAltArr.splice(1, 0, radioValue);
        var altStr = newAltArr.toString();;
        var t = altStr.replace(/,/g, '-');
        $product_img_cell.each(function() {
                $(this).remove();
                for (var tr = 0; tr < $product_img_cell_array.length; tr++) {
                    var a = $product_img_cell_array[tr].attr("data-title");
                    (t != a && "main_image" != a && "main_image_hex" != a) || $("#productImg .flickity-slider").append($product_img_cell_array[tr]);
                }
            }),
            (a = tr ? 1 : 0),
          
            $product_slider.flickity("destroy"),
            $("#productImg").flickity({
                pageDots: !0,
                initialIndex: a
            });
    });


$("#back_btn").click(function (){
  window.history.back();
});


 $(document).ready(function(){
      if(window.matchMedia("(max-width: 767px)").matches){
          $('.product-block--title').prependTo('.product__images');
          $('.product-block--price').appendTo('.product-block--title');
          $('.product-block--text').appendTo('.product-block--price');
      } 
  });

$(window).scroll(function (event) {
    var height = $(window).height();
    var scroll = $(window).scrollTop();
    //console.log(scroll + " " + height);
    if(scroll > height){
     $(".sticky_cart").addClass("show");
    } else {
     $(".sticky_cart").removeClass("show");
    }
});




$(document).ready(function(){
	onload();
	
	//Main Function
	function onload() {
		
		if ($(".modal_price").data('display-campaign')) {
		    var timeonload = setInterval(function() {
				console.log("onload function calling .....");
				var salePer = $(".modal_price").data('campaign-discount');
				var currentPrice = $('.price .money').text().replace("$","").replace(",","");
				console.log(currentPrice);
				clearInterval(timeonload);
				var percentage = currentPrice * salePer / 100;
				var percentage = percentage.toFixed(3);
				var final = currentPrice - percentage;
				var final = final.toFixed(2);
				var final = window.Shopify.formatMoney(final, $('body').data('money-format'));
				
				$(".modal_price").find(".compare-at-price").html($('.price .money').text());
				$(".footer-p-price").find(".was-price").html($('.price .money').text());
				$(".modal_price").find(".price .money").html(final);
				$(".footer-p-price").find(".money").html(final);
				console.log(final);
			}, 1000);
		}
	}
	
	// Change price on varient selection - Start 
	if ($(".modal_price").data('display-campaign')) {
		$(document).on("click", ".swatch-element", function() {
			setTimeout(function() {
				//onload();
					var salePer = $(".modal_price").data('campaign-discount');
					var currentPrice = $('.price .money').text().replace("$","").replace(",","");
					console.log(currentPrice);
					var percentage = currentPrice * salePer / 100;
					var percentage = percentage.toFixed(3);
					var final = currentPrice - percentage;
					var final = final.toFixed(2);
					var final = window.Shopify.formatMoney(final, $('body').data('money-format'));
					$(".modal_price").find(".compare-at-price").html($('.price .money').text());
					$(".footer-p-price").find(".was-price").html($('.price .money').text());
					$(".modal_price").find(".price .money").html(final);
					$(".footer-p-price").find(".money").html(final);
					console.log(final);
			}, 200);
		});
	}
	// Change price on varient selection - End
	
});


jQuery(document).ready(function() {
        // Toggle modal visibility
        jQuery('.modal-toggle').on('click', function(e) {
            e.preventDefault();
            jQuery('.offer-modal').toggleClass('is-visible');
            jQuery('body').toggleClass('modal-open');
        });

        // Close modal when clicking on the close button
        jQuery('.close').on('click', function() {
            jQuery('.offer-modal').removeClass('is-visible');
            jQuery('body').removeClass('modal-open');
        });

        // Close modal when clicking outside of it
        jQuery(document).on('click', function(e) {
            if (jQuery('.offer-modal').hasClass('is-visible') && !jQuery(e.target).closest('.offer-modal').length && !jQuery(e.target).closest('.modal-toggle').length) {
                jQuery('.offer-modal').removeClass('is-visible');
                jQuery('body').removeClass('modal-open');
            }
        });
    });

$(".search-submit").click(function() {
        $(".search_form").submit();
    });

 
 





